(function(){
  'use strict';
  var STORAGE_KEY='pmyAccessibility2026';

  function ready(fn){
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn,{once:true});
    else fn();
  }

  function loadPrefs(){
    try{
      var raw=localStorage.getItem(STORAGE_KEY);
      if(!raw) return {};
      var value=JSON.parse(raw);
      return value&&typeof value==='object'?value:{};
    }catch(e){return {};}
  }

  function savePrefs(prefs){
    try{localStorage.setItem(STORAGE_KEY,JSON.stringify(prefs));}catch(e){}
  }

  function applyPrefs(prefs,root){
    var html=document.documentElement;
    html.classList.toggle('pmy-a11y-large-text',!!prefs.largeText);
    html.classList.toggle('pmy-a11y-high-contrast',!!prefs.contrast);
    html.classList.toggle('pmy-a11y-underline-links',!!prefs.underline);
    html.classList.toggle('pmy-a11y-reduce-motion',!!prefs.reduceMotion);
    html.classList.toggle('pmy-a11y-readable-font',!!prefs.readableFont);
    html.classList.toggle('pmy-a11y-text-spacing',!!prefs.textSpacing);
    if(root){
      root.querySelectorAll('[data-pmy-a11y-option]').forEach(function(button){
        var key=button.getAttribute('data-pmy-a11y-option');
        button.setAttribute('aria-pressed',prefs[key]?'true':'false');
      });
    }
  }

  function mountCurrency(root){
    var slot=root.querySelector('[data-pmy-currency-slot]');
    var select=root.querySelector('#pmy-currency-select');
    var form=root.querySelector('#pmy_currency_form');
    if(!slot||!select||!form) return;
    if(select.options.length<2){slot.remove();return;}

    var header=document.querySelector('.header-nav-container');
    if(!header) return;
    var themeGroup=header.querySelector('.theme-lang-group');
    var actions=header.querySelector('.header-actions') || (themeGroup&&themeGroup.parentElement) || header;
    if(themeGroup&&themeGroup.parentElement===actions) actions.insertBefore(slot,themeGroup);
    else actions.appendChild(slot);
    slot.hidden=false;

    select.addEventListener('change',function(){
      if(form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
  }

  function mountAccessibility(root){
    var trigger=root.querySelector('[data-pmy-a11y-trigger]');
    var panel=root.querySelector('[data-pmy-a11y-panel]');
    var close=root.querySelector('[data-pmy-a11y-close]');
    var reset=root.querySelector('[data-pmy-a11y-reset]');
    var backdrop=root.querySelector('[data-pmy-a11y-backdrop]');
    if(!trigger||!panel) return;

    var footer=document.querySelector('.main-footer');
    var shell=footer&&footer.querySelector('.footer-shell');
    var trio=footer&&footer.querySelector('[data-pmy-footer-utility-trio]');
    var host=trio||shell;
    if(host){
      var row=host.querySelector('.pmy-a11y-footer-row');
      if(!row){
        row=document.createElement('div');
        row.className='pmy-a11y-footer-row';
        host.appendChild(row);
      }
      row.appendChild(trigger);
    }

    var prefs=loadPrefs();
    applyPrefs(prefs,root);
    var lastFocus=null;

    function openPanel(){
      lastFocus=document.activeElement;
      panel.hidden=false;
      if(backdrop) backdrop.hidden=false;
      document.documentElement.classList.add('pmy-a11y-open');
      trigger.setAttribute('aria-expanded','true');
      requestAnimationFrame(function(){
        var first=panel.querySelector('button');
        if(first) first.focus({preventScroll:true});
      });
    }

    function closePanel(){
      panel.hidden=true;
      if(backdrop) backdrop.hidden=true;
      document.documentElement.classList.remove('pmy-a11y-open');
      trigger.setAttribute('aria-expanded','false');
      if(lastFocus&&lastFocus.focus) lastFocus.focus({preventScroll:true});
    }

    trigger.addEventListener('click',function(){panel.hidden?openPanel():closePanel();});
    if(close) close.addEventListener('click',closePanel);
    if(backdrop) backdrop.addEventListener('click',closePanel);

    root.querySelectorAll('[data-pmy-a11y-option]').forEach(function(button){
      button.addEventListener('click',function(){
        var key=button.getAttribute('data-pmy-a11y-option');
        prefs[key]=!prefs[key];
        savePrefs(prefs);
        applyPrefs(prefs,root);
      });
    });

    if(reset){
      reset.addEventListener('click',function(){
        prefs={};
        savePrefs(prefs);
        applyPrefs(prefs,root);
      });
    }

    document.addEventListener('keydown',function(event){if(event.key==='Escape'&&!panel.hidden) closePanel();});
    document.addEventListener('pointerdown',function(event){
      if(panel.hidden) return;
      if(panel.contains(event.target)||trigger.contains(event.target)) return;
      closePanel();
    });
  }

  ready(function(){
    var root=document.querySelector('[data-pmy-global-utilities]');
    if(!root) return;
    mountCurrency(root);
    mountAccessibility(root);
  });
})();

(function () {
  var current = document.currentScript;
  if (!current || !current.src) return;
  var started = false;
  var privacyStarted = false;
  var retries = 0;

  function asset(name, version) {
    return current.src.replace(/pmy-global-utilities\.js(?:\?.*)?$/, name + '?v=' + version);
  }

  function privacyAllowsTracking() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return false;
      return !!cp.analyticsProcessingAllowed() && !!cp.marketingAllowed();
    } catch (e) {
      return false;
    }
  }

  function loadTracking() {
    if (started || !privacyAllowsTracking()) return;
    started = true;
    var main = document.createElement('script');
    main.src = asset('pmy-tracking.js', 'pmytrack20260911d');
    main.async = false;
    main.onload = function () {
      var micro = document.createElement('script');
      micro.src = asset('pmy-tracking-micro.js', 'pmymicro20260911b');
      micro.async = false;
      micro.onload = function () {
        var deep = document.createElement('script');
        deep.src = asset('pmy-tracking-deep.js', 'pmydeep20260911b');
        deep.async = false;
        document.head.appendChild(deep);
      };
      document.head.appendChild(micro);
    };
    document.head.appendChild(main);
  }

  function initPrivacy() {
    if (privacyStarted) return;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      retries += 1;
      if (retries < 20) setTimeout(initPrivacy, 150);
      return;
    }
    privacyStarted = true;
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return;
        loadTracking();
        document.addEventListener('visitorConsentCollected', loadTracking);
      }
    );
  }

  initPrivacy();
})();

(function(){
  'use strict';

  function ready(fn){
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn,{once:true});
    else fn();
  }

  ready(function(){
    if(!('speechSynthesis' in window) || !('SpeechSynthesisUtterance' in window)) return;

    var root=document.querySelector('[data-pmy-global-utilities]');
    if(!root) return;
    var options=root.querySelector('.pmy-a11y-options');
    if(!options || options.querySelector('[data-pmy-a11y-speech]')) return;

    var synth=window.speechSynthesis;
    var state='idle';
    var chunks=[];
    var index=0;
    var runToken=0;
    var currentUtterance=null;

    var copy={
      en:{idle:'Listen to page',pause:'Pause reading',resume:'Resume reading'},
      pt:{idle:'Ouvir página',pause:'Pausar leitura',resume:'Continuar leitura'},
      nl:{idle:'Pagina beluisteren',pause:'Lezen pauzeren',resume:'Lezen hervatten'},
      ar:{idle:'الاستماع إلى الصفحة',pause:'إيقاف القراءة مؤقتًا',resume:'استئناف القراءة'},
      de:{idle:'Seite vorlesen',pause:'Vorlesen pausieren',resume:'Vorlesen fortsetzen'},
      es:{idle:'Escuchar página',pause:'Pausar lectura',resume:'Reanudar lectura'},
      fr:{idle:'Écouter la page',pause:'Mettre en pause',resume:'Reprendre la lecture'},
      it:{idle:'Ascolta la pagina',pause:'Metti in pausa',resume:'Riprendi lettura'},
      he:{idle:'האזנה לעמוד',pause:'השהיית ההקראה',resume:'המשך ההקראה'}
    };

    function getLocale(){
      var raw=(document.documentElement.getAttribute('lang') || navigator.language || 'en-US').replace('_','-');
      return raw || 'en-US';
    }

    function getLanguageKey(){
      var base=getLocale().toLowerCase().split('-')[0];
      return copy[base]?base:'en';
    }

    var labels=copy[getLanguageKey()];
    var button=document.createElement('button');
    button.type='button';
    button.className='pmy-a11y-option pmy-a11y-option--speech';
    button.setAttribute('data-pmy-a11y-speech','');
    button.setAttribute('aria-pressed','false');
    button.innerHTML='<span aria-hidden="true"><svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 10v4h3l4 3V7L8 10H5Z"/><path d="M15.5 9a4 4 0 0 1 0 6"/><path d="M18 6.5a7.5 7.5 0 0 1 0 11"/></svg></span><strong></strong>';
    var label=button.querySelector('strong');
    label.textContent=labels.idle;
    options.appendChild(button);

    if(!document.getElementById('pmy-a11y-speech-style')){
      var style=document.createElement('style');
      style.id='pmy-a11y-speech-style';
      style.textContent='.pmy-a11y-option--speech{grid-column:1/-1;min-height:62px!important;flex-direction:row!important;align-items:center!important;justify-content:flex-start!important;gap:12px!important}.pmy-a11y-option--speech>span{flex:0 0 34px!important;width:34px!important;height:34px!important;border-radius:50%!important}.pmy-a11y-option--speech strong{font-size:12px!important}.pmy-a11y-option--speech[aria-pressed="true"]>span{background:#006600!important;color:#fff!important}html[data-bs-theme="dark"] .pmy-a11y-option--speech[aria-pressed="true"]>span{background:#fff!important;color:#006600!important}';
      document.head.appendChild(style);
    }

    function updateButton(){
      if(state==='speaking'){
        label.textContent=labels.pause;
        button.setAttribute('aria-pressed','true');
      }else if(state==='paused'){
        label.textContent=labels.resume;
        button.setAttribute('aria-pressed','true');
      }else{
        label.textContent=labels.idle;
        button.setAttribute('aria-pressed','false');
      }
    }

    function normalizeText(text){
      return String(text||'').replace(/\s+/g,' ').trim();
    }

    function getReadableText(){
      var source=document.querySelector('main') || document.querySelector('[role="main"]') || document.body;
      if(!source) return '';
      var clone=source.cloneNode(true);
      var removeSelectors=[
        'script','style','noscript','template','svg','canvas','iframe','video','audio',
        'input','select','textarea','button','form','option',
        '[hidden]','[aria-hidden="true"]','[role="dialog"]','[role="button"]',
        '[data-pmy-global-utilities]','.pmy-checkout-drawer','.pmy-sr-only','.visually-hidden'
      ];
      if(source===document.body){
        removeSelectors.push('header','nav','footer');
      }
      clone.querySelectorAll(removeSelectors.join(',')).forEach(function(node){node.remove();});
      return normalizeText(clone.textContent);
    }

    function makeChunks(text,max){
      var result=[];
      var remaining=normalizeText(text);
      max=max||210;
      while(remaining.length>max){
        var sample=remaining.slice(0,max+1);
        var candidates=[sample.lastIndexOf('. '),sample.lastIndexOf('! '),sample.lastIndexOf('? '),sample.lastIndexOf('; '),sample.lastIndexOf(': '),sample.lastIndexOf(', ')];
        var cut=Math.max.apply(Math,candidates);
        if(cut<90) cut=sample.lastIndexOf(' ');
        if(cut<60) cut=max;
        var part=remaining.slice(0,cut+1).trim();
        if(part) result.push(part);
        remaining=remaining.slice(cut+1).trim();
      }
      if(remaining) result.push(remaining);
      return result;
    }

    function chooseVoice(locale){
      var voices=synth.getVoices?synth.getVoices():[];
      if(!voices || !voices.length) return null;
      var exact=String(locale||'').toLowerCase();
      var base=exact.split('-')[0];
      var voice=null;
      for(var i=0;i<voices.length;i++){
        if(String(voices[i].lang||'').toLowerCase()===exact){voice=voices[i];break;}
      }
      if(voice) return voice;
      for(var j=0;j<voices.length;j++){
        if(String(voices[j].lang||'').toLowerCase().split('-')[0]===base){voice=voices[j];break;}
      }
      return voice;
    }

    function finish(token){
      if(token!==runToken) return;
      currentUtterance=null;
      chunks=[];
      index=0;
      state='idle';
      updateButton();
    }

    function speakNext(token){
      if(token!==runToken) return;
      if(index>=chunks.length){finish(token);return;}

      var locale=getLocale();
      var utterance=new SpeechSynthesisUtterance(chunks[index++]);
      currentUtterance=utterance;
      utterance.lang=locale;
      utterance.rate=.98;
      utterance.pitch=1;
      utterance.volume=1;
      var voice=chooseVoice(locale);
      if(voice) utterance.voice=voice;

      utterance.onend=function(){
        if(token!==runToken) return;
        window.setTimeout(function(){speakNext(token);},35);
      };
      utterance.onerror=function(event){
        if(token!==runToken) return;
        if(event && (event.error==='canceled' || event.error==='interrupted')) return;
        finish(token);
      };

      state='speaking';
      updateButton();
      synth.speak(utterance);
    }

    function stopReading(){
      runToken+=1;
      try{synth.cancel();}catch(e){}
      currentUtterance=null;
      chunks=[];
      index=0;
      state='idle';
      updateButton();
    }

    function startReading(){
      stopReading();
      var text=getReadableText();
      if(!text) return;
      chunks=makeChunks(text,210);
      if(!chunks.length) return;
      index=0;
      runToken+=1;
      var token=runToken;
      speakNext(token);
    }

    button.addEventListener('click',function(){
      if(state==='idle'){
        startReading();
      }else if(state==='speaking'){
        try{synth.pause();state='paused';updateButton();}catch(e){stopReading();}
      }else if(state==='paused'){
        try{synth.resume();state='speaking';updateButton();}catch(e){stopReading();}
      }
    });

    var reset=root.querySelector('[data-pmy-a11y-reset]');
    if(reset) reset.addEventListener('click',stopReading);
    window.addEventListener('pagehide',stopReading);
  });
})();


/* PMY a11y reader controls v2 */
(function(){
  'use strict';
  function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn,{once:true});else fn()}
  ready(function(){
    var root=document.querySelector('[data-pmy-global-utilities]');
    var button=root&&root.querySelector('[data-pmy-a11y-speech]');
    var stop=root&&root.querySelector('[data-pmy-a11y-speech-stop]');
    if(!root||!button||!('speechSynthesis' in window)||!('SpeechSynthesisUtterance' in window))return;
    var synth=window.speechSynthesis,state='idle',chunks=[],index=0,token=0;
    var label=button.querySelector('[data-pmy-a11y-speech-label]');
    function update(){
      if(!label)return;
      label.textContent=state==='speaking'?button.dataset.labelPause:(state==='paused'?button.dataset.labelResume:button.dataset.labelIdle);
      button.setAttribute('aria-pressed',state==='idle'?'false':'true');
    }
    function stopReading(){
      token+=1;try{synth.cancel()}catch(e){}
      state='idle';chunks=[];index=0;update();
    }
    function text(){
      var source=document.querySelector('main')||document.querySelector('[role="main"]')||document.body;
      if(!source)return'';
      var clone=source.cloneNode(true);
      clone.querySelectorAll('script,style,noscript,template,svg,canvas,iframe,video,audio,input,select,textarea,button,form,option,[hidden],[aria-hidden="true"],[role="dialog"],[role="button"],[data-pmy-global-utilities],.pmy-checkout-drawer,.pmy-sr-only,.visually-hidden').forEach(function(n){n.remove()});
      return String(clone.textContent||'').replace(/\s+/g,' ').trim();
    }
    function next(run){
      if(run!==token)return;
      if(index>=chunks.length){state='idle';update();return}
      var u=new SpeechSynthesisUtterance(chunks[index++]);
      u.lang=document.documentElement.lang||navigator.language||'en-US';
      u.rate=.98;u.pitch=1;u.volume=1;
      u.onend=function(){setTimeout(function(){next(run)},30)};
      u.onerror=function(e){if(e&&(e.error==='canceled'||e.error==='interrupted'))return;state='idle';update()};
      state='speaking';update();synth.speak(u);
    }
    function start(){
      stopReading();
      var content=text();if(!content)return;
      chunks=content.match(/.{1,210}(?:\s|$)/g)||[content];
      index=0;token+=1;next(token);
    }
    button.addEventListener('click',function(){
      if(state==='idle')start();
      else if(state==='speaking'){try{synth.pause();state='paused';update()}catch(e){stopReading()}}
      else{try{synth.resume();state='speaking';update()}catch(e){stopReading()}}
    });
    if(stop)stop.addEventListener('click',stopReading);
    var reset=root.querySelector('[data-pmy-a11y-reset]');
    if(reset)reset.addEventListener('click',stopReading);
    window.addEventListener('pagehide',stopReading);
    update();
  });
})();

/* PMY feedback layer 2026-09-22: replaces native browser alerts with localized inline validation/toasts. */
(function(){
  'use strict';
  if(window.PMYFeedback&&window.PMYFeedback.version)return;

  var copy={
    en:{date:'Please select a date.',unavailableDay:'This day of the week is not available.',unavailableDate:'This date is fully booked or unavailable.',language:'Please select a language.',email:'Please enter a valid e-mail.',phone:'Please enter a phone number.',travelers:'Please select at least one traveler.',time:'Please select a preferred time.',capacity:'This experience allows a maximum of {max} people.',checkout:'We could not complete your request. Please try again.',copied:'Link copied to clipboard!'},
    pt:{date:'Selecione uma data.',unavailableDay:'Este dia da semana não está disponível.',unavailableDate:'Esta data está esgotada ou indisponível.',language:'Selecione um idioma.',email:'Introduza um e-mail válido.',phone:'Introduza um número de telefone.',travelers:'Selecione pelo menos um viajante.',time:'Selecione um horário preferencial.',capacity:'Esta experiência permite no máximo {max} pessoas.',checkout:'Não foi possível concluir o pedido. Tente novamente.',copied:'Link copiado!'},
    nl:{date:'Selecteer een datum.',unavailableDay:'Deze dag van de week is niet beschikbaar.',unavailableDate:'Deze datum is volgeboekt of niet beschikbaar.',language:'Selecteer een taal.',email:'Voer een geldig e-mailadres in.',phone:'Voer een telefoonnummer in.',travelers:'Selecteer minstens één reiziger.',time:'Selecteer een voorkeurstijd.',capacity:'Deze ervaring is geschikt voor maximaal {max} personen.',checkout:'We konden je aanvraag niet voltooien. Probeer het opnieuw.',copied:'Link gekopieerd!'},
    ar:{date:'يرجى اختيار تاريخ.',unavailableDay:'هذا اليوم من الأسبوع غير متاح.',unavailableDate:'هذا التاريخ محجوز بالكامل أو غير متاح.',language:'يرجى اختيار اللغة.',email:'يرجى إدخال بريد إلكتروني صالح.',phone:'يرجى إدخال رقم هاتف.',travelers:'يرجى اختيار مسافر واحد على الأقل.',time:'يرجى اختيار الوقت المفضل.',capacity:'الحد الأقصى لهذه التجربة هو {max} أشخاص.',checkout:'تعذر إكمال الطلب. يرجى المحاولة مرة أخرى.',copied:'تم نسخ الرابط!'},
    de:{date:'Bitte wählen Sie ein Datum.',unavailableDay:'Dieser Wochentag ist nicht verfügbar.',unavailableDate:'Dieses Datum ist ausgebucht oder nicht verfügbar.',language:'Bitte wählen Sie eine Sprache.',email:'Bitte geben Sie eine gültige E-Mail-Adresse ein.',phone:'Bitte geben Sie eine Telefonnummer ein.',travelers:'Bitte wählen Sie mindestens einen Reisenden.',time:'Bitte wählen Sie eine bevorzugte Uhrzeit.',capacity:'Diese Erfahrung ist für maximal {max} Personen verfügbar.',checkout:'Ihre Anfrage konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.',copied:'Link kopiert!'},
    es:{date:'Selecciona una fecha.',unavailableDay:'Este día de la semana no está disponible.',unavailableDate:'Esta fecha está completa o no disponible.',language:'Selecciona un idioma.',email:'Introduce un correo electrónico válido.',phone:'Introduce un número de teléfono.',travelers:'Selecciona al menos un viajero.',time:'Selecciona un horario preferido.',capacity:'Esta experiencia admite un máximo de {max} personas.',checkout:'No pudimos completar la solicitud. Inténtalo de nuevo.',copied:'¡Enlace copiado!'},
    fr:{date:'Sélectionnez une date.',unavailableDay:'Ce jour de la semaine n’est pas disponible.',unavailableDate:'Cette date est complète ou indisponible.',language:'Sélectionnez une langue.',email:'Saisissez une adresse e-mail valide.',phone:'Saisissez un numéro de téléphone.',travelers:'Sélectionnez au moins un voyageur.',time:'Sélectionnez un horaire préféré.',capacity:'Cette expérience accueille au maximum {max} personnes.',checkout:'Nous n’avons pas pu finaliser votre demande. Réessayez.',copied:'Lien copié !'},
    it:{date:'Seleziona una data.',unavailableDay:'Questo giorno della settimana non è disponibile.',unavailableDate:'Questa data è al completo o non disponibile.',language:'Seleziona una lingua.',email:'Inserisci un indirizzo e-mail valido.',phone:'Inserisci un numero di telefono.',travelers:'Seleziona almeno un viaggiatore.',time:'Seleziona un orario preferito.',capacity:'Questa esperienza ammette un massimo di {max} persone.',checkout:'Non è stato possibile completare la richiesta. Riprova.',copied:'Link copiato!'},
    he:{date:'יש לבחור תאריך.',unavailableDay:'יום זה בשבוע אינו זמין.',unavailableDate:'תאריך זה מלא או אינו זמין.',language:'יש לבחור שפה.',email:'יש להזין כתובת דוא״ל תקינה.',phone:'יש להזין מספר טלפון.',travelers:'יש לבחור לפחות מטייל אחד.',time:'יש לבחור שעה מועדפת.',capacity:'החוויה מוגבלת לעד {max} אנשים.',checkout:'לא ניתן היה להשלים את הבקשה. נסו שוב.',copied:'הקישור הועתק!'}
  };

  function language(){
    var base=(document.documentElement.lang||'en').toLowerCase().split('-')[0];
    return copy[base]?base:'en';
  }
  function plain(value){return String(value==null?'':value).replace(/\s+/g,' ').trim();}
  function normalized(value){
    var s=plain(value).toLowerCase();
    try{s=s.normalize('NFD').replace(/[\u0300-\u036f]/g,'');}catch(e){}
    return s;
  }
  function classify(message){
    var s=normalized(message);
    if(!s)return'';
    if(/link copied|link copiado|lien copie|link gekopieerd|enlace copiado|link kopiert/.test(s))return'copied';
    if(/day of the week|dia da semana|wochenta|jour de la semaine|giorno della settimana/.test(s))return'unavailableDay';
    if(/fully booked|date is not available|date.*unavailable|data.*indispon|fecha.*dispon|datum.*beschikbaar|date.*indisponible/.test(s))return'unavailableDate';
    if(/select.*date|selecione.*data|selecciona.*fecha|selecteer.*datum|datum.*wahlen|selectionnez.*date|seleziona.*data/.test(s))return'date';
    if(/select.*language|selecione.*idioma|selecciona.*idioma|selecteer.*taal|sprache.*wahlen|selectionnez.*langue|seleziona.*lingua/.test(s))return'language';
    if(/valid.*e-?mail|e-?mail.*valid|correo.*valido|adresse e-?mail valide|e-mailadres/.test(s))return'email';
    if(/phone number|numero de telefone|telefono|telephone|telefonnummer|telefoonnummer/.test(s))return'phone';
    if(/preferred time|horario prefer|hora prefer|preference.*time|voorkeurstijd|uhrzeit|horaire prefere|orario prefer/.test(s))return'time';
    if((/traveler|traveller|ticket|session|viajant|ingresso|sessao|sessão|reisend|voyageur|viaggiator/.test(s))&&(/select|at least|pelo menos|mindestens|au moins|almeno/.test(s)))return'travelers';
    if(/italy experience|maximum|maximo|maximo|max\.|capacity|capacidade|capacidad/.test(s)&&/\d/.test(s))return'capacity';
    if(/checkout|went wrong|could not|erro ao processar|ocorreu um erro|try again|tente novamente|error processing/.test(s))return'checkout';
    return'';
  }
  function messageFor(key,original){
    if(!key)return plain(original);
    var value=(copy[language()]&&copy[language()][key])||copy.en[key]||plain(original);
    if(key==='capacity'){
      var match=plain(original).match(/\b(\d{1,2})\b/);
      value=value.replace('{max}',match?match[1]:'');
    }
    return value;
  }
  function visible(node){
    if(!node||node.disabled)return false;
    if(node.type==='hidden')return false;
    return !!(node.offsetWidth||node.offsetHeight||node.getClientRects().length);
  }
  function firstVisible(selectors){
    for(var i=0;i<selectors.length;i++){
      var nodes=document.querySelectorAll(selectors[i]);
      for(var j=0;j<nodes.length;j++)if(visible(nodes[j]))return nodes[j];
    }
    return null;
  }
  function controlFor(key){
    if(key==='date'||key==='unavailableDay'||key==='unavailableDate')return firstVisible(['#booking-date','#chk-date','input[type="date"]','input[id*="date" i]','.pmy-date-trigger']);
    if(key==='language')return firstVisible(['#checkout-lang-select','#booking-language','select[id*="lang" i]','select[name*="language" i]','.pmy-select-trigger[data-for*="lang" i]']);
    if(key==='email')return firstVisible(['input[type="email"]','input[id*="email" i]']);
    if(key==='phone')return firstVisible(['input[type="tel"]','input[id*="phone" i]:not([type="hidden"])']);
    if(key==='time')return firstVisible(['select[id*="time" i]','input[id*="time" i]','.pmy-select-trigger[data-for*="time" i]']);
    if(key==='travelers')return firstVisible(['.traveler-qty','.qty-input','input[id*="qty" i]','input[id*="traveler" i]']);
    return null;
  }
  function travelerHost(){
    var selectors=['#dynamic-travelers-container','.tickets-open-list','.traveler-list','.passengers-wrapper','.m-variants-list','.m-ticket-list'];
    for(var i=0;i<selectors.length;i++){
      var n=document.querySelector(selectors[i]);
      if(n&&visible(n))return n;
    }
    return null;
  }
  function clearInline(scope){
    var root=scope||document;
    root.querySelectorAll('.pmy-inline-feedback[data-pmy-inline-feedback]').forEach(function(n){n.remove();});
    root.querySelectorAll('.pmy-invalid-control').forEach(function(n){n.classList.remove('pmy-invalid-control');n.removeAttribute('aria-invalid');});
  }
  function inline(message,key){
    var control=controlFor(key);
    var special=key==='travelers'&&!control?travelerHost():null;
    var anchor=control||special;
    if(!anchor)return false;

    var group=anchor.closest&&anchor.closest('.form-group-custom,.pmy-checkout-field,.form-group,.pmy-form-group,.booking-field,.m-form-group,.field,.pmy-field,.booking-form') || anchor.parentElement || anchor;
    clearInline(group);

    if(control){
      control.classList.add('pmy-invalid-control');
      control.setAttribute('aria-invalid','true');
    }
    var note=document.createElement('div');
    note.className='pmy-inline-feedback';
    note.setAttribute('data-pmy-inline-feedback','');
    note.setAttribute('role','alert');
    note.textContent=message;
    if(group===anchor||special)anchor.insertAdjacentElement('afterend',note);
    else group.appendChild(note);

    var cleaner=function(){
      note.remove();
      if(control){control.classList.remove('pmy-invalid-control');control.removeAttribute('aria-invalid');}
      if(control){
        control.removeEventListener('input',cleaner);
        control.removeEventListener('change',cleaner);
      }
    };
    if(control){
      control.addEventListener('input',cleaner,{once:true});
      control.addEventListener('change',cleaner,{once:true});
      try{control.focus({preventScroll:true});}catch(e){}
    }
    return true;
  }
  function toast(message,type){
    var container=document.getElementById('pmy-feedback-toasts');
    if(!container){
      container=document.createElement('div');
      container.id='pmy-feedback-toasts';
      container.className='pmy-feedback-toasts';
      container.setAttribute('aria-live','polite');
      container.setAttribute('aria-atomic','false');
      document.body.appendChild(container);
    }
    var item=document.createElement('div');
    item.className='pmy-feedback-toast is-'+(type||'error');
    item.setAttribute('role',type==='error'?'alert':'status');
    var icon=document.createElement('span');
    icon.className='pmy-feedback-toast__icon';
    icon.setAttribute('aria-hidden','true');
    icon.textContent=type==='success'?'✓':'!';
    var txt=document.createElement('span');
    txt.className='pmy-feedback-toast__text';
    txt.textContent=message;
    var close=document.createElement('button');
    close.type='button';
    close.className='pmy-feedback-toast__close';
    close.setAttribute('aria-label','Close');
    close.textContent='×';
    close.onclick=function(){item.remove();};
    item.append(icon,txt,close);
    container.appendChild(item);
    requestAnimationFrame(function(){item.classList.add('is-visible');});
    window.setTimeout(function(){
      item.classList.remove('is-visible');
      window.setTimeout(function(){item.remove();},220);
    },type==='success'?2800:5200);
  }
  function show(raw,options){
    var original=plain(raw);
    if(!original)return;
    options=options||{};
    var key=options.key||classify(original);
    var message=options.message||messageFor(key,original);
    var type=options.type||(key==='copied'?'success':'error');
    var inlineKeys={date:1,unavailableDay:1,unavailableDate:1,language:1,email:1,phone:1,travelers:1,time:1};
    if(options.inline!==false&&inlineKeys[key]&&inline(message,key))return;
    toast(message,type);
  }

  window.PMYFeedback={version:'2026-09-22',show:show,clear:function(){clearInline(document);}};
  window.alert=function(message){show(message);};
})();


/* PMY feedback layer 2026-09-22 */
(function(){
'use strict';
if(window.PMYFeedback&&window.PMYFeedback.version)return;
var C={
en:{date:'Please select a date.',day:'This day of the week is not available.',unavailable:'This date is fully booked or unavailable.',language:'Please select a language.',email:'Please enter a valid e-mail.',phone:'Please enter a phone number.',travelers:'Please select at least one traveler.',time:'Please select a preferred time.',checkout:'We could not complete your request. Please try again.',copied:'Link copied to clipboard!'},
pt:{date:'Selecione uma data.',day:'Este dia da semana não está disponível.',unavailable:'Esta data está esgotada ou indisponível.',language:'Selecione um idioma.',email:'Introduza um e-mail válido.',phone:'Introduza um número de telefone.',travelers:'Selecione pelo menos um viajante.',time:'Selecione um horário preferencial.',checkout:'Não foi possível concluir o pedido. Tente novamente.',copied:'Link copiado!'},
nl:{date:'Selecteer een datum.',day:'Deze dag van de week is niet beschikbaar.',unavailable:'Deze datum is volgeboekt of niet beschikbaar.',language:'Selecteer een taal.',email:'Voer een geldig e-mailadres in.',phone:'Voer een telefoonnummer in.',travelers:'Selecteer minstens één reiziger.',time:'Selecteer een voorkeurstijd.',checkout:'We konden je aanvraag niet voltooien. Probeer het opnieuw.',copied:'Link gekopieerd!'},
ar:{date:'يرجى اختيار تاريخ.',day:'هذا اليوم من الأسبوع غير متاح.',unavailable:'هذا التاريخ محجوز بالكامل أو غير متاح.',language:'يرجى اختيار اللغة.',email:'يرجى إدخال بريد إلكتروني صالح.',phone:'يرجى إدخال رقم هاتف.',travelers:'يرجى اختيار مسافر واحد على الأقل.',time:'يرجى اختيار الوقت المفضل.',checkout:'تعذر إكمال الطلب. يرجى المحاولة مرة أخرى.',copied:'تم نسخ الرابط!'},
de:{date:'Bitte wählen Sie ein Datum.',day:'Dieser Wochentag ist nicht verfügbar.',unavailable:'Dieses Datum ist ausgebucht oder nicht verfügbar.',language:'Bitte wählen Sie eine Sprache.',email:'Bitte geben Sie eine gültige E-Mail-Adresse ein.',phone:'Bitte geben Sie eine Telefonnummer ein.',travelers:'Bitte wählen Sie mindestens einen Reisenden.',time:'Bitte wählen Sie eine bevorzugte Uhrzeit.',checkout:'Ihre Anfrage konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.',copied:'Link kopiert!'},
es:{date:'Selecciona una fecha.',day:'Este día de la semana no está disponible.',unavailable:'Esta fecha está completa o no disponible.',language:'Selecciona un idioma.',email:'Introduce un correo electrónico válido.',phone:'Introduce un número de teléfono.',travelers:'Selecciona al menos un viajero.',time:'Selecciona un horario preferido.',checkout:'No pudimos completar la solicitud. Inténtalo de nuevo.',copied:'¡Enlace copiado!'},
fr:{date:'Sélectionnez une date.',day:'Ce jour de la semaine n’est pas disponible.',unavailable:'Cette date est complète ou indisponible.',language:'Sélectionnez une langue.',email:'Saisissez une adresse e-mail valide.',phone:'Saisissez un numéro de téléphone.',travelers:'Sélectionnez au moins un voyageur.',time:'Sélectionnez un horaire préféré.',checkout:'Nous n’avons pas pu finaliser votre demande. Réessayez.',copied:'Lien copié !'},
it:{date:'Seleziona una data.',day:'Questo giorno della settimana non è disponibile.',unavailable:'Questa data è al completo o non disponibile.',language:'Seleziona una lingua.',email:'Inserisci un indirizzo e-mail valido.',phone:'Inserisci un numero di telefono.',travelers:'Seleziona almeno un viaggiatore.',time:'Seleziona un orario preferito.',checkout:'Non è stato possibile completare la richiesta. Riprova.',copied:'Link copiato!'},
he:{date:'יש לבחור תאריך.',day:'יום זה בשבוע אינו זמין.',unavailable:'תאריך זה מלא או אינו זמין.',language:'יש לבחור שפה.',email:'יש להזין כתובת דוא״ל תקינה.',phone:'יש להזין מספר טלפון.',travelers:'יש לבחור לפחות מטייל אחד.',time:'יש לבחור שעה מועדפת.',checkout:'לא ניתן היה להשלים את הבקשה. נסו שוב.',copied:'הקישור הועתק!'}
};
function lang(){var b=(document.documentElement.lang||'en').toLowerCase().split('-')[0];return C[b]?b:'en'}
function txt(v){return String(v==null?'':v).replace(/\s+/g,' ').trim()}
function norm(v){var s=txt(v).toLowerCase();try{s=s.normalize('NFD').replace(/[\u0300-\u036f]/g,'')}catch(e){}return s}
function key(v){var s=norm(v);if(/link copied|link copiado|lien copie|link gekopieerd|enlace copiado|link kopiert/.test(s))return'copied';if(/day of the week|dia da semana|jour de la semaine|giorno della settimana|wochentag/.test(s))return'day';if(/fully booked|date is not available|date.*unavailable|data.*indispon|fecha.*dispon|datum.*beschikbaar|date.*indisponible/.test(s))return'unavailable';if(/select.*date|selecione.*data|selecciona.*fecha|selecteer.*datum|datum.*wahlen|selectionnez.*date|seleziona.*data/.test(s))return'date';if(/select.*language|selecione.*idioma|selecciona.*idioma|selecteer.*taal|sprache.*wahlen|selectionnez.*langue|seleziona.*lingua/.test(s))return'language';if(/valid.*e-?mail|e-?mail.*valid|correo.*valido|e-mailadres/.test(s))return'email';if(/phone number|numero de telefone|telefono|telephone|telefonnummer|telefoonnummer/.test(s))return'phone';if(/preferred time|horario prefer|horaire prefere|orario prefer|voorkeurstijd|uhrzeit/.test(s))return'time';if(/traveler|traveller|ticket|session|viajant|ingresso|sessao|sessão|reisend|voyageur|viaggiator/.test(s)&&/select|at least|pelo menos|mindestens|au moins|almeno/.test(s))return'travelers';if(/checkout|went wrong|could not|erro ao processar|ocorreu um erro|try again|tente novamente|error processing/.test(s))return'checkout';return''}
function visible(n){return n&&!n.disabled&&n.type!=='hidden'&&!!(n.offsetWidth||n.offsetHeight||n.getClientRects().length)}
function pick(list){for(var i=0;i<list.length;i++){var a=document.querySelectorAll(list[i]);for(var j=0;j<a.length;j++)if(visible(a[j]))return a[j]}return null}
function control(k){if(k==='date'||k==='day'||k==='unavailable')return pick(['#booking-date','#chk-date','input[type="date"]','input[id*="date" i]','.pmy-date-trigger']);if(k==='language')return pick(['#checkout-lang-select','#booking-language','select[id*="lang" i]','select[name*="language" i]']);if(k==='email')return pick(['input[type="email"]','input[id*="email" i]']);if(k==='phone')return pick(['input[type="tel"]','input[id*="phone" i]:not([type="hidden"])']);if(k==='time')return pick(['select[id*="time" i]','input[id*="time" i]']);if(k==='travelers')return pick(['.traveler-qty','.qty-input','input[id*="qty" i]']);return null}
function inline(message,k){var c=control(k);if(!c)return false;var g=c.closest('.form-group-custom,.pmy-checkout-field,.form-group,.pmy-form-group,.booking-field,.m-form-group,.field,.pmy-field')||c.parentElement;if(!g)return false;g.querySelectorAll('.pmy-inline-feedback').forEach(function(n){n.remove()});c.classList.add('pmy-invalid-control');c.setAttribute('aria-invalid','true');var n=document.createElement('div');n.className='pmy-inline-feedback';n.setAttribute('role','alert');n.textContent=message;g.appendChild(n);var clear=function(){n.remove();c.classList.remove('pmy-invalid-control');c.removeAttribute('aria-invalid')};c.addEventListener('input',clear,{once:true});c.addEventListener('change',clear,{once:true});try{c.focus({preventScroll:true})}catch(e){}return true}
function toast(message,type){var host=document.getElementById('pmy-feedback-toasts');if(!host){host=document.createElement('div');host.id='pmy-feedback-toasts';host.className='pmy-feedback-toasts';host.setAttribute('aria-live','polite');document.body.appendChild(host)}var n=document.createElement('div');n.className='pmy-feedback-toast is-'+type;n.setAttribute('role',type==='error'?'alert':'status');n.innerHTML='<span class="pmy-feedback-toast__icon" aria-hidden="true">'+(type==='success'?'✓':'!')+'</span><span class="pmy-feedback-toast__text"></span><button type="button" class="pmy-feedback-toast__close" aria-label="Close">×</button>';n.querySelector('.pmy-feedback-toast__text').textContent=message;n.querySelector('button').onclick=function(){n.remove()};host.appendChild(n);requestAnimationFrame(function(){n.classList.add('is-visible')});setTimeout(function(){n.classList.remove('is-visible');setTimeout(function(){n.remove()},220)},type==='success'?2800:5200)}
function show(raw,opt){opt=opt||{};var original=txt(raw);if(!original)return;var k=opt.key||key(original);var message=opt.message||(k&&C[lang()][k]?C[lang()][k]:original);var type=opt.type||(k==='copied'?'success':'error');if(opt.inline!==false&&/^(date|day|unavailable|language|email|phone|travelers|time)$/.test(k)&&inline(message,k))return;toast(message,type)}
window.PMYFeedback={version:'2026-09-22',show:show};
window.alert=function(message){show(message)};
})();
